"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.AuthClient = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _cookie = require("@tajawal/web-core-sdk-v2/lib/services/cookie.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _login = require("../utils/login.utils");
var _constants = require("../constants");
var _auth = require("../utils/auth.utils");
const AuthClient = {
  setTokens(data, ctx) {
    (0, _auth.setTokens)(data, ctx);
  },
  clearTokens(ctx) {
    (0, _auth.clearTokens)(ctx);
  },
  /**
   * set user token on http header
   * * @param {string} token
   */
  setToken(token) {
    _http.$http.addHeaders({
      Authorization: `Bearer ${token}`
    });
  },
  /**
   * register user
   * @param {string} FirstName
   * @param {string} LastName
   * @param {string} email
   * @param {string} password
   * @param {string} passwordVerify
   * @param {object} phone
   * @returns {Promise<unknown>}
   */
  register({
    FirstName,
    LastName,
    email,
    password,
    passwordVerify,
    phone,
    subscribe,
    captchaToken
  }) {
    const requestId = 'REGISTER_USER';
    const endPoint = _constants.ENDPOINTS.REGISTER;
    const data = {
      FirstName,
      LastName,
      email,
      password,
      passwordVerify,
      phone,
      subscribe,
      captchaToken
    };
    if (!data.phone.code || !data.phone.number) {
      delete data.phone;
    }
    return _http.$http.post(requestId, endPoint, {
      data
    }).then(({
      data
    }) => data);
  },
  /**
   * login user
   * @param {string} email
   * @param {string} phone
   * @param {string} password
   * @returns {Promise<unknown>}
   */
  login({
    email,
    phone,
    password,
    captchaToken
  }) {
    const requestId = 'LOGIN_USER';
    const endPoint = _constants.ENDPOINTS.LOGIN;
    const data = {
      password,
      captchaToken,
      grant_type: _constants.GRANT_TYPES.PASSWORD
    };
    if (email.length > 0) {
      data.email = email;
    } else {
      data.phoneNumber = phone.number;
      data.phoneCode = phone.code;
    }
    return _http.$http.post(requestId, endPoint, {
      data: (0, _auth.encodeData)(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(({
      data
    }) => {
      _cookie.$cookie.set(_constants.STORAGE_KEYS.USER_HASHING, data.md5User);
      _cookie.$cookie.set(_constants.STORAGE_KEYS.USER_BASE64, (0, _login.getUserBase64)(email));
      AuthClient.setTokens(data);
      return data;
    });
  },
  /**
   * logout user
   */
  logout(all = false) {
    const requestId = 'LOGOUT_USER';
    const endPoint = _constants.ENDPOINTS.LOGOUT;
    const token = _cookie.$cookie.get(_constants.STORAGE_KEYS.AUTH_TOKEN);
    return _http.$http.post(requestId, endPoint, {
      data: (0, _auth.encodeData)({
        token,
        all
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(({
      data
    }) => {
      AuthClient.clearTokens();
      return data;
    });
  },
  /**
   * forgot password
   * @param {string} email
   * @param {object} phone
   * @returns {Promise<unknown>}
   */
  forgotPassword({
    email,
    phone,
    captchaToken
  }) {
    const requestId = 'FORGOT_PASSWORD';
    const endPoint = _constants.ENDPOINTS.FORGOT_PASSWORD;
    const data = {};
    if (email.length > 0) data.email = email;else data.phone = phone;
    data.captchaToken = captchaToken;
    return _http.$http.post(requestId, endPoint, {
      data
    }).then(({
      data
    }) => data);
  },
  /**
   * reset password
   * @param {string} accountType
   * @param {string} token
   * @param {string} requestId
   * @param {string} password
   * @param {string} passwordVerify
   * @returns {Promise<unknown>}
   */
  resetPassword({
    accountType,
    token,
    requestId,
    password,
    passwordVerify,
    captchaToken,
    revokeAll
  }) {
    const requestKey = 'RESET_PASSWORD';
    const data = {
      token,
      requestId,
      password,
      passwordVerify,
      captchaToken,
      revokeAll
    };
    const endPoint = accountType === 'phone' ? _constants.ENDPOINTS.RESET_PASSWORD_PHONE : _constants.ENDPOINTS.RESET_PASSWORD_EMAIL;
    return _http.$http.post(requestKey, endPoint, {
      data
    }).then(({
      data
    }) => {
      AuthClient.setTokens(data);
      AuthClient.setToken(data.access_token);
      return data;
    });
  },
  /**
   * reset password phone
   * @param {string} token
   * @param {string} requestId
   * @param {string} password
   * @param {string} passwordVerify
   * @returns {Promise<unknown>}
   */
  resetPasswordPhone({
    token,
    requestId,
    password,
    passwordVerify
  }) {
    const requestKey = 'RESET_PASSWORD';
    const data = {
      token,
      requestId,
      password,
      passwordVerify
    };
    const endPoint = _constants.ENDPOINTS.RESET_PASSWORD_PHONE;
    return _http.$http.post(requestKey, endPoint, {
      data
    }).then(({
      data
    }) => data);
  },
  /**
   * verify reset password
   * @param {string} token
   * @returns {Promise<unknown>}
   */
  verifyResetPassword({
    token
  }) {
    const requestId = 'VERIFY_RESET_PASSWORD';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.VERIFY_RESET_PASSWORD, {
      token
    });
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   * change password
   * @param {string} userId
   * @param {string} newPassword
   * @param {string} oldPassword
   * @returns {Promise<unknown>}
   */
  changePassword({
    userId,
    newPassword,
    oldPassword,
    revokeAll
  }) {
    const requestId = 'VERIFY_RESET_PASSWORD';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.CHANGE_PASSWORD, {
      userId
    });
    return _http.$http.post(requestId, endPoint, {
      data: {
        newPassword,
        oldPassword,
        revokeAll
      }
    }).then(({
      data
    }) => {
      AuthClient.setTokens(data);
      AuthClient.setToken(data.access_token);
      return data;
    });
  },
  /**
   * verify user by email
   * @param {string} email
   * @param {string} token
   * @param {string} requestId
   * @returns {Promise<unknown>}
   */
  verifyUserByEmail({
    email,
    token,
    requestId
  }) {
    const reqId = 'VERIFY_USER_EMAIL';
    const endPoint = _constants.ENDPOINTS.VERIFY_USER_EMAIL;
    return _http.$http.post(reqId, endPoint, {
      data: {
        email,
        token,
        requestId
      }
    }).then(({
      data
    }) => data);
  },
  /**
   * resend verify by email
   * @param {string} email
   * @returns {Promise<unknown>}
   */
  reSendVerifyEmail({
    email
  }) {
    const reqId = 'RESEND_VERIFY_EMAIL';
    const endPoint = _constants.ENDPOINTS.RESEND_VERIFY_EMAIL;
    return _http.$http.post(reqId, endPoint, {
      data: {
        email
      }
    }).then(({
      data
    }) => data);
  },
  /**
   * resend verify by phone
   * @param {string} email
   * @returns {Promise<unknown>}
   */
  reSendVerifyPhone({
    phone,
    captchaToken
  }) {
    const reqId = 'RESEND_VERIFY_PHONE';
    const endPoint = _constants.ENDPOINTS.RESEND_VERIFY_PHONE;
    return _http.$http.post(reqId, endPoint, {
      data: {
        phone,
        captchaToken
      }
    }).then(({
      data
    }) => data);
  },
  /**
   * Check OTP Status
   * @param token
   * @param requestId
   * @returns {Promise<unknown>}
   */
  checkOTPStatus({
    token,
    requestId
  }) {
    const reqId = 'CHECK_OTP_STATUS';
    const endPoint = _constants.ENDPOINTS.CHECK_OTP_STATUS;
    const data = {
      token,
      requestId
    };
    return _http.$http.post(reqId, endPoint, {
      data
    }).then(({
      data
    }) => data);
  },
  /**
   * verify user by phone
   * @param token
   * @param requestId
   * @returns {Promise<unknown>}
   */
  verifyUserByPhone({
    token,
    requestId
  }) {
    const reqId = 'VERIFY_USER_PHONE';
    const endPoint = _constants.ENDPOINTS.VERIFY_USER_PHONE;
    return _http.$http.post(reqId, endPoint, {
      data: {
        token,
        requestId
      }
    }).then(({
      data
    }) => data);
  },
  /**
   * update registration
   * @param {string} email, {object} phone
   * @returns {Promise<unknown>}
   */
  updateRegistration({
    email,
    phone,
    captchaToken
  }) {
    const reqId = 'UPDATE_REGISTRATION';
    const endPoint = _constants.ENDPOINTS.UPDATE_REGISTRATION;
    const data = {};
    if ((email === null || email === void 0 ? void 0 : email.length) > 0) data.email = email;else data.phone = phone;
    data.captchaToken = captchaToken;
    return _http.$http.post(reqId, endPoint, {
      data
    }).then(({
      data
    }) => data);
  },
  /**
   * refresh token
   * * @param {object} ctx
   * * @param {boolean} reload
   * @returns {Promise<unknown>}
   */
  refreshToken(ctx, reload = false, silentLogoutHttpService = null) {
    const requestId = 'REFRESH_TOKEN';
    const endPoint = _constants.ENDPOINTS.LOGIN;
    const refresh_token = (0, _auth.getCookie)(ctx, _constants.STORAGE_KEYS.REFRESH_TOKEN);
    const data = {
      grant_type: _constants.GRANT_TYPES.REFRESH_TOKEN,
      refresh_token
    };
    _auth.refreshToken.startGettingRefreshToken();
    return _http.$http.post(requestId, endPoint, {
      data: (0, _auth.encodeData)(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...(ctx ? {
          'x-authorization': (0, _auth.getCookie)(ctx, _constants.STORAGE_KEYS.ENIGMA_API_TOKEN)
        } : {})
      }
    }).then(({
      data
    }) => {
      console.log('REFRESH TOKEN SUCCESS');
      AuthClient.setTokens(data, ctx);
      _auth.refreshToken.endGettingRefreshToken();
      if (reload && typeof window !== 'undefined' && window.location) {
        window.location.reload();
      }
      return data;
    }).catch(error => {
      _auth.refreshToken.endGettingRefreshToken();
      if (!error || _axios.default.isCancel(error)) {
        return undefined;
      }
      console.log('REFRESH TOKEN ERR', {
        error
      });
      AuthClient.clearTokens(ctx);

      // window.location.reload();
      if (typeof window !== 'undefined' && window.location) {
        // window.location.href = '/mweb/login';
        window.location.reload();
      } else if (silentLogoutHttpService) {
        silentLogoutHttpService.removeHeaders(['Authorization']);
      } else {
        // ctx.res.writeHead(302, { Location: '/mweb/login' });
        // ctx.res.end();
      }
      return error;
    });
  },
  /**
   * Sign in with apple client
   * @param {string} userId
   * @param {string} token
   * @returns {Promise<unknown>}
   */

  appleLogin({
    userId,
    token,
    email,
    name
  }) {
    const requestId = 'SIGN_IN_WITH_APPLE';
    const endPoint = _constants.ENDPOINTS.SIGN_IN_WITH_APPLE;
    const data = {
      token,
      userId,
      provider: 'apple'
    };
    if (email) {
      data.email = email;
    }
    if (name) {
      data.name = name;
    }
    return _http.$http.post(requestId, endPoint, {
      data
    }).then(({
      data
    }) => {
      AuthClient.setTokens(data);
      return data;
    });
  },
  deleteAppleAccount({
    userId,
    authorizationCode,
    reason,
    provider,
    captchaToken
  }) {
    const requestId = 'DELETE_APPLE_ACCOUNT';
    const endPoint = _constants.ENDPOINTS.DELETE_APPLE_ACCOUNT;
    const data = {
      userId,
      authorizationCode,
      reason,
      provider,
      captchaToken
    };
    return _http.$http.post(requestId, endPoint, {
      data
    }).then(({
      data
    }) => {
      return data;
    });
  }
};
exports.AuthClient = AuthClient;